export default __webpack_public_path__ + "static/media/close.fab75c4c.svg";